import { createContext, useContext, useState, useEffect } from 'react';

const NavigationContext = createContext();

export const VIEWS = {
  DASHBOARD:           'dashboard',
  BITACORA:            'bitacora',
  CONTROL_MANUAL:      'control_manual',
  SUSCRIPTORES:        'suscriptores',
  CAMBIO_TURNO:        'cambio_turno',
  PLACAS_AUTORIZADAS:  'placas_autorizadas',
  CONFIGURACIONES:     'configuraciones',
  TARIFAS:             'tarifas',
  SALIDAS_PROGRAMADAS: 'salidas_programadas',
  USUARIOS:            'usuarios',
  REPORTERIA:          'reporteria',
  ESCAPES:             'escapes',
  SERVICIOS:           'servicios',
  PAGOS_PENDIENTES:    'pagos_pendientes',
  SUCURSALES:          'sucursales',
};

// Mapa vista → hash URL
const ROUTE_MAP = {
  [VIEWS.DASHBOARD]:          '/dashboard',
  [VIEWS.BITACORA]:           '/bitacora',
  [VIEWS.CONTROL_MANUAL]:     '/control-camaras',
  [VIEWS.SUSCRIPTORES]:       '/suscriptores',
  [VIEWS.CAMBIO_TURNO]:       '/historial-cierre',
  [VIEWS.PLACAS_AUTORIZADAS]: '/placas-autorizadas',
  [VIEWS.CONFIGURACIONES]:    '/configuraciones',
  [VIEWS.TARIFAS]:            '/tarifas',
  [VIEWS.SALIDAS_PROGRAMADAS]:'/salidas-automaticas',
  [VIEWS.USUARIOS]:           '/usuarios',
  [VIEWS.REPORTERIA]:         '/reporteria',
  [VIEWS.ESCAPES]:            '/escapes',
  [VIEWS.SERVICIOS]:          '/servicios',
  [VIEWS.PAGOS_PENDIENTES]:   '/pagos-pendientes',
  [VIEWS.SUCURSALES]:         '/sucursales',
};

// Mapa inverso hash → vista
const VIEW_FROM_ROUTE = Object.fromEntries(
  Object.entries(ROUTE_MAP).map(([view, route]) => [route, view])
);

const getHashRoute = () => {
  const hash = window.location.hash.replace('#', '') || '/dashboard';
  return hash;
};

const getViewFromHash = () => {
  const route = getHashRoute();
  return VIEW_FROM_ROUTE[route] || VIEWS.DASHBOARD;
};

export const useNavigation = () => {
  const ctx = useContext(NavigationContext);
  if (!ctx) throw new Error('useNavigation must be used within NavigationProvider');
  return ctx;
};

export const NavigationProvider = ({ children }) => {
  const [currentView, setCurrentView] = useState(getViewFromHash);

  const navigate = (view) => {
    const route = ROUTE_MAP[view] || '/dashboard';
    window.location.hash = route;
    setCurrentView(view);
  };

  const goBack = () => navigate(VIEWS.DASHBOARD);

  // Escuchar cambios de hash (botones atrás/adelante del browser)
  useEffect(() => {
    const onHashChange = () => {
      const view = getViewFromHash();
      setCurrentView(view);
    };
    window.addEventListener('hashchange', onHashChange);
    return () => window.removeEventListener('hashchange', onHashChange);
  }, []);

  // Sincronizar hash al montar si no coincide
  useEffect(() => {
    const route = ROUTE_MAP[currentView] || '/dashboard';
    if (window.location.hash !== '#' + route) {
      window.location.hash = route;
    }
  }, []); // eslint-disable-line

  return (
    <NavigationContext.Provider value={{ currentView, navigate, goBack, ROUTE_MAP }}>
      {children}
    </NavigationContext.Provider>
  );
};
